"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var canUseDOM_1 = __importDefault(require("../canUseDOM"));
/**
 * Function to get value to localstorage
 * @param {string} KEY
 * @returns {any | undefined}
 */


function getItem(KEY) {
  try {
    if (canUseDOM_1.default) {
      var result = localStorage.getItem(KEY);
      return result;
    }

    return undefined;
  } catch (_a) {
    return undefined;
  }
}

exports.default = getItem;